/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Password reset request.

Test accounts use the reserved .test domain. EmailStr rejects that TLD,
so this accepts the same addresses the user record already stores.
 */
export interface PasswordResetRequest {
  email: string;
}
